import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IndentWrapper } from '@yme/components/Separator';
import { ProductCarousel } from '@yme/organisms/product-carousel';
import { buildRequestUrl, getProducts } from '@yme/organisms/product-carousel/helpers';
import { getProductCarouselData } from '@yme/organisms/product-carousel/services';
import { getDaysToShowNew } from '@yme/selectors/index';
import { getProductCarouselParams } from '@yme/selectors/products';
import { BEST_SELLERS_TEST_ID, MIN_CARDS_TO_SHOWED } from './constants';
export function BestSellers(props) {
    const { cards, hyperdriveEndpoint, isRemoveBottomIndent, labels } = props;
    const { bestSellers_header_label: bestSellersTitleLabel } = labels;
    const [isLoaded, setIsLoaded] = useState(false);
    const [productData, setProductData] = useState([]);
    const productCarouselCommonParams = useSelector(getProductCarouselParams);
    const daysToShowNew = useSelector(getDaysToShowNew);
    const dispatch = useDispatch();
    const successCb = (resp) => {
        const data = getProducts({
            data: resp?.data?.results,
            iconConfig: {
                isNewLabelForUnitShowed: true,
            },
            isFilterAvailableVariant: true,
        });
        setIsLoaded(true);
        const filteredData = data?.filter((item) => item.price && item.isSomeVariantHasStock && item.eComEnabled);
        setProductData(filteredData);
    };
    useEffect(() => {
        dispatch(getProductCarouselData(buildRequestUrl(hyperdriveEndpoint, cards), successCb));
    }, [cards, dispatch, hyperdriveEndpoint]);
    if ((isLoaded && (!productData || productData?.length < MIN_CARDS_TO_SHOWED)) || !cards.length) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(ProductCarousel, { dataTestId: BEST_SELLERS_TEST_ID, title: bestSellersTitleLabel, cards: cards, commonParams: productCarouselCommonParams, products: productData, minCardsToShow: MIN_CARDS_TO_SHOWED, daysToShowNew: daysToShowNew, isDataLoaded: isLoaded })));
}
BestSellers.displayName = 'BestSellers_AEMComponent';
